import DefaultCell from "application/components/DefaultCell";
import { CodeBlueMenu } from "globals/configuration/codeBlue";
import { CodeBlueViewerMenu } from "globals/configuration/codeBlueViewer";
const getAttributesByRole = (isViewer) => {
  return {
    enableAddButton: false,
    enableUpdateTableRecords: true,
    enableAdvanceSearch: true,
    enableDownloadButton: true,
    enableDownloadPdf: true,
    enableRefresh: true,
    modes: isViewer
      ? CodeBlueViewerMenu.map((item) => {
          return {
            id: item.key,
            name: item.name,
            iconName: item.icon,
            url: item.url,
            description: item.description,
          };
        })
      : CodeBlueMenu.map((item) => {
          return {
            id: item.key,
            name: item.name,
            iconName: item.icon,
            url: item.url,
            description: item.description,
          };
        }),
  };
};

const operationURLS = {
  list: "/codeBlueReport/list",
  pdfDownload: "/codeBlueReport/generateAndDownloadPdf",
  csvDownload: "/codeBlueReport/downloadCSV",
};

const getColumns = () => {
  return [
    {
      Header: "Caller Number",
      accessor: "callerIdNumber",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      displayInDeleteConfirmation: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "IVR Start Time",
      accessor: "ivrStarttime",
      displayInList: true,
      allowFilter: false,
      dataType: "date",
      dateTime: true,
      displayInDeleteConfirmation: true,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "IVR End Time",
      accessor: "ivrEndtime",
      displayInList: true,
      allowFilter: false,
      dataType: "date",
      dateTime: true,
      displayInDeleteConfirmation: true,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "IVR Duration",
      accessor: "ivrDuration",
      displayInList: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },

    {
      Header: "Access Code",
      accessor: "accessCode",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      displayInDeleteConfirmation: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Code Name",
      accessor: "codeBlueType",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      displayInDeleteConfirmation: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Dial Number",
      accessor: "dialNumber",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      dateTime: true,
      displayInDeleteConfirmation: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Start Time",
      accessor: "startTime",
      displayInList: true,
      allowFilter: true,
      dataType: "date",
      dateTime: true,
      displayInDeleteConfirmation: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Answer Time",
      accessor: "answerTime",
      displayInList: true,
      allowFilter: false,
      dataType: "date",
      dateTime: true,
      displayInDeleteConfirmation: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "End Time",
      accessor: "endtime",
      displayInList: true,
      allowFilter: true,
      dateTime: true,
      dataType: "date",
      displayInDeleteConfirmation: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Duration",
      accessor: "duration",
      displayInList: true,
      allowFilter: false,
      dataType: "integer",
      displayInDeleteConfirmation: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Hang Up Cause",
      accessor: "hangupCause",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      displayInDeleteConfirmation: true,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },

    {
      Header: "SMS Text",
      accessor: "smsText",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      displayInDeleteConfirmation: true,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Send Time",
      accessor: "executionTime",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      displayInDeleteConfirmation: true,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "status",
      accessor: "Status",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      displayInDeleteConfirmation: true,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Coral DialId",
      accessor: "coralDialId",
      displayInList: false,
      allowFilter: false,
      dataType: "string",
      displayInDeleteConfirmation: true,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
  ];
};

export { getColumns, getAttributesByRole, operationURLS };
